import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RoleListLayer from '../components/RoleListLayer'

const RoleListPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title='Role Management' />
      <RoleListLayer />
    </MasterLayout>
  )
}

export default RoleListPage

